import React from "react";
import FormGroupSelectInput from "../formGroupSelectInput";
import FormGroupDateInput from "../General/formGroupDateInput";
import Button from "../button";
import moment from "moment";
import FormGroupPlainText from "../formGroupPlainText";
import FormGroupRadioInput from "../formGroupRadioInput";
import FormResponseMessage from "../formResponseMessage";
import {TEXT_CONFIRM_SOLICITOR_GROUP_UPDATE, TEXT_DECLINE_SOLICITOR_GROUP_UPDATE} from "../../helpers/variables";

class SolicitorGroupAddUnderwriterForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            form: {
                underwriter: null,
                validFrom: null,
                updateRelatedPolicies: null,
            },
            errorMessage: null,
        }
    }

    componentDidMount() {
        if(this.props.initialUW){
            this.setState({
                form: {
                    underwriter: this.props.initialUW.underwriterId,
                    validFrom: moment(this.props.initialUW.validFrom).format('DD/MM/YYYY'),
                    updateRelatedPolicies: null,
                }
            })
        }
    }

    handleSelectChange = evt => {
        this.setState({
            form: {
                ...this.state.form,
                underwriter: evt.target.value
            }
        });
    }

    handleDateChange = (name, value) => {
        this.setState({
            form: {
                ...this.state.form,
                [name]: value
            }
        }, () => {
            if(moment(value, 'DD/MM/YYYY').isAfter(moment(), 'days')){
                this.setState({
                    form: {
                        ...this.state.form,
                        updateRelatedPolicies: null
                    }
                })
            }
        });

    }

    handleSubmit = (evt) => {
        evt.preventDefault();

        // user has not selected underwriter
        if(!this.state.form.underwriter) {
            return this.setState({
                errorMessage: 'Underwriter is required'
            })
        }

        // user has selected a valid from date in the past that may affect policies without answering if he indeed
        // wants to update possible related live policies
        if(
            moment(this.state.form.validFrom, 'DD/MM/YYYY').isSameOrBefore(moment(), 'days')
            && !this.state.form.updateRelatedPolicies
        ) {
            return this.setState({
                errorMessage: 'You have to specify if you want to update all policies'
            });

        }this.props.submitUnderwriter({
            ...this.state.form,
            updateRelatedPolicies: this.state.form.updateRelatedPolicies === 'yes'
        });
    }

    handleRadioSelect = (evt) => {
        this.setState({
            form: {
                ...this.state.form,
                [evt.target.name]: evt.target.value
            }
        });
    }

    render() {
        const {underwriters, submitUnderwriter, minDate, maxDate} = this.props;
        const underWriterSelectOptions = [
            {
                key: '',
                value: 'Please, select an underwriter.'
            },
            ...this.props.underwriters.map((underwriter) => {
                    return {key: underwriter.id, value: underwriter.name}
                }
            )];

        return (
            <div className={'form-horizontal'}>
                <FormGroupSelectInput
                    Multiple={false}
                    Name="selectedUnderwriter"
                    Value={this.state.form.underwriter || ''}
                    Required={true}
                    SelectStyle={'form-control solicitorGroup-select-underwriter'}
                    LeftWrapper="col-sm-3"
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    RightWrapper=""
                    HandleInputChange={this.handleSelectChange}
                    Label="Capacity Underwriter"
                    Options={underWriterSelectOptions}
                />
                <FormGroupDateInput
                    centerClassName="col-sm-6"
                    leftClassName="col-sm-3"
                    label={'Date from'}
                    required={true}
                    name={'validFrom'}
                    type="text"
                    value={this.state.form.validFrom || ''}
                    handleInputChange={this.handleDateChange}
                    autoComplete={'off'}
                    min={minDate}
                    max={maxDate}
                />
                {(
                    moment(this.state.form.validFrom, 'DD/MM/YYYY').isSameOrBefore(moment(), 'days')
                ) && (
                    <div>
                        <hr/>
                        <FormGroupPlainText
                            leftWrapper={"col-sm-12"}
                            Label={'There may be existing policies linked to this underwriter, by continuing these policies will be updated with a new underwriter. Do you want to update all policies in this date range?'}
                        />
                        <FormGroupRadioInput
                            value={this.state.form.updateRelatedPolicies}
                            name={'updateRelatedPolicies'}
                            inputWrapper={'col-sm-12'}
                            onChange={this.handleRadioSelect}
                            options={[
                                {
                                    key: 'yes',
                                    label: TEXT_CONFIRM_SOLICITOR_GROUP_UPDATE.replace('__date__', this.state.form.validFrom)
                                },
                                {
                                    key: 'no',
                                    label: TEXT_DECLINE_SOLICITOR_GROUP_UPDATE
                                }
                            ]}
                        />
                        <hr/>
                    </div>
                )}
                {
                    this.state.errorMessage && (
                        <FormResponseMessage
                            Message={this.state.errorMessage}
                            LeftWrapper="col-sm-3"
                            CenterWrapper="col-sm-6 "
                            MessageStyle="formResponseMessage-reject"
                        />
                    )
                }
                <div className={'form-group'}>
                    <div className={'col-sm-9 col-sm-offset-3'}>
                        <Button
                            clickHandler={this.handleSubmit}
                            type={'submit'}
                            wrapper="btn-wrapper"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label={this.props.initialUW ? "Edit" : "Add" }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default SolicitorGroupAddUnderwriterForm;